import { QUANTITY_MODES } from 'screens/Applications&WorkOrders/StepsLayout/Components/ProductsStep/components/FillProductDetailsDrawer/constants';
import WATER_CARRIER_PRODUCT_ID from 'screens/Applications&WorkOrders/StepsLayout/Constants/carrierProductId';

const INITIAL_CARRIER_PRODUCT = {
  id: WATER_CARRIER_PRODUCT_ID,
  name: 'Water',
  manufacturer: 'Carrier',
  productType: '',
  quantityMode: QUANTITY_MODES.RATE_PER_TANK,
  ratePerAreaUnit: 'gallon',
  totalProductUnit: 'gallon',
  ratePerTankUnit: 'gallon',
  totalProduct: '',
  ratePerTank: '',
  ratePerAcre: '',
  priceValue: null,
  priceUnit: null,
  saveAsNewListPrice: false,
  totalArea: 0,
  totalAppliedAcreage: 0,
  coveragePercent: 100,
  applicationMethod: '',
  targetPests: [],
  custom: false,
  stdpackageunit: '',
  stdfactor: 0,
  stdunit: '',
  isCarrier: true
};

export default INITIAL_CARRIER_PRODUCT;
